export enum EquipmentSelectionType {
	Bathrooms = 1,
	EntranceDoors = 2,
	InnerDoors = 3,
	Floors = 4
}
